import React from 'react'
import * as Bs from 'react-bootstrap'
import * as Bsr from 'react-router-bootstrap'

/**
 * Full screen backdrop image
 */
class CreditCard extends React.Component {
  static propTypes = {
    stripeCustomer: React.PropTypes.object
  }

  render() {
    const card = this.props.stripeCustomer.get('card')

    return (
      <Bs.Panel bsStyle="info">
        <p><i>We have the following credit card associated with your account:</i></p>
        <p>
          <b>{card.get('name')}</b><br/>
          Card ending in: {card.get('last4')}<br/>
          Type: {card.get('type')}<br/>
          Expires: {card.get('expMonth')}/{card.get('expYear')}
        </p>
        <Bsr.ButtonLink
          bsSize="xsmall"
          bsStyle="success"
          to="change-card">
          Change card
        </Bsr.ButtonLink>
        &nbsp;
        <Bsr.ButtonLink
          bsSize="xsmall"
          bsStyle="warning"
          to="purchase-credits">
          Purchase credits
        </Bsr.ButtonLink>
      </Bs.Panel>
    )
  }
}

export default CreditCard



// WEBPACK FOOTER //
// ./modules/shared/components/creditCard.js